import axios from "axios";

import Config from "../../config";

const getActionMensagemLida = data => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chats/chat/mensagem-lida`,
        data
    });
};

export default getActionMensagemLida;
